import { format } from 'date-fns';
import { ChildBase } from '@unicorn/sdui';
import { INPUT_SPEC_START } from '../model';
import { PayloadFieldValue, TicketPayloadField } from '../types';

const checkIfDateAndCompile = (
  value: any,
  spec: ChildBase['spec']
): PayloadFieldValue => {
  if (!(value instanceof Date)) return value;

  if (Array.isArray(value)) {
    return value.map((item) => checkIfDateAndCompile(item, spec)) as PayloadFieldValue;
  }

  if (spec === 'input-date') {
    return format(value, 'yyyy-MM-dd');
  }

  return format(value, 'yyyy-MM-dd HH:mm:ss');
};

export const getPayloadFileds = (sduiData: ChildBase[]): TicketPayloadField[] =>
  sduiData
    .filter(({ spec }) => spec.startsWith(INPUT_SPEC_START))
    .map(({ token, data, spec }) => ({
      token,
      value: checkIfDateAndCompile(data.value, spec),
    }));
